import { Info } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function TarefaSystemMessage({ msg }: { msg: any }) {
  return (
    <div className="my-4 flex w-full justify-center duration-300 animate-in fade-in zoom-in-95">
      <div className="flex items-center gap-2 rounded-full border border-border/50 bg-muted/50 px-4 py-1.5 text-[11px] font-medium text-muted-foreground shadow-sm">
        <Info className="h-3.5 w-3.5 text-muted-foreground/70" />
        <span>{msg.mensagem}</span>
        {msg.criadoEm && (
          <span className="ml-1 opacity-60">
            • {format(new Date(msg.criadoEm), "HH:mm", { locale: ptBR })}
          </span>
        )}
      </div>
    </div>
  );
}
